window.viewerIndexSetDate = async () => {
	const date = document.querySelector('[name=select_date]').value
	const params = new URLSearchParams()
	params.append('date',date)
	const response = await axios.post('/viewer/index/setdate',params)
	location.reload()
}
window.viewerIndexSetRooms = async () => {
	const rooms = document.querySelectorAll('[name=room_id]:checked')
	const roomList = []
	rooms.forEach((room) => {
		roomList.push(room.value)
	})
	if(roomList.length>0)
	{
		location.href = '/viewer/room/list/'+roomList.join('_')
	}
	else
	{
		alert('会場が選択されていません。')
	}
}

window.viewerReceptSetDate = async () => {
	const date = document.querySelector('[name=recept_day]').value
	const params = new URLSearchParams()
	params.append('date',date)
	const response = await axios.post('/viewer/recept/setdate',params)
	location.reload()
}

let count = 0
window.viewerMainLoopFlg = true;
window.viewerMainLoop = async (intervalSpan) => {
	if (window.viewerMainLoopFlg) {
		count++;
		const page = document.getElementById('page').value
		const params = new URLSearchParams()
		params.append('page',page)
		var response = '';
		if (page == "main") {
			response = await axios.get("/viewer/index/get_room_list")
		} else if(page == "list") {
			response = await axios.get("/viewer/room/contents_list/"+mRoomIds)
		} else if(page == "detail") {
			response = await axios.get("/viewer/room/contents_detail/"+mRoomId)
		} else {
			response = await axios.post("/viewer/room/contents", params)
		}
		const data = response.data
		switch(page)
		{
			case 'index':
				for(let index=0;index<data.length;index++) {
					const card = document.getElementById('room_card_'+data[index].m_room_id)
					if (card) {
						congestionClassAdd(card,String(data[index]?.program_and_active_sub_has_one?.congestion_cd || 1));
						if (data[index]?.program_and_active_sub_has_one) {
							card.querySelector('.__frame').classList.remove('d-none')
						} else {
							card.querySelector('.__frame').classList.add('d-none')
						}
						card.querySelector('[data-id="__presentation"]').classList.remove('is__active')
						if ((data[index]?.program_and_active_sub_has_one?.reception_status_cd || 1) == 2) {
							card.querySelector('[data-id="__presentation"]').classList.add('is__active')
						}
						card.querySelector('[data-id="seminar_name"]').innerText = data[index]?.program_and_active_sub_has_one?.seminar_name||'未使用';

						card.querySelector('[data-id="performer_name"]').innerText = data[index]?.program_and_active_sub_has_one?.performer_name+'　先生' || '-------------';

						card.querySelector('[data-id="program_no"]').innerText = data[index]?.program_and_active_sub_has_one?.program_no || '--';
						card.querySelector('[data-id="program_title"]').innerText = data[index]?.program_and_active_sub_has_one?.program_title || '---';
						card.querySelector('[data-id="time"]').innerText = (data[index]?.program_and_active_sub_has_one?.program_time_from ||'--:--') + ' - ' + data[index]?.program_and_active_sub_has_one?.program_time_to || '--:--'
					}
				}
				break
			case 'detail':
				/**
				 * 元のコンテンツと最新のコンテンツと比較
				 */

				if (initContents.length == 0 && data.rows.length !=0) {
					initContents = data.rows;
					mRoom = data.room;
					$('.presentation-one-room').empty().append(data.html);
				} else {
					if (initContents.length != data.rows.length) {
						initContents = data.rows;
						$('.presentation-one-room').empty().append(data.html);
					}
					if (JSON.stringify(mRoom) != JSON.stringify(data.room)) {
						mRoom = data.room;
						$('.presentation-one-room').empty().append(data.html);
					}
		
					Object.keys(initContents).map(function(key, idx) {
						let keyIndex = data.rows.ourIndexOf(initContents[key].t_pgm_id,'t_pgm_id');
						if (keyIndex === -1) {
							initContents = data.rows;
							$('.presentation-one-room').empty().append(data.html);
						}
		
						if (JSON.stringify(initContents[key]) != JSON.stringify(data.rows[keyIndex])) {
							initContents = data.rows;
							$('.presentation-one-room').empty().append(data.html);
						}
					});
				}
				break;
			case 'list':
				/**
				 * 元のコンテンツと最新のコンテンツと比較
				 */
				if (initContents.length == 0 && data.rows.length !=0) {
					initContents = data.rows;
					mRoom = data.rooms;
					$('.presentation-every-room').empty().append(data.html);
				} else {
					Object.keys(initContents).map(function(key, idx) {
						if (typeof data.rows[key] == "undefined") {
							initContents = data.rows;
							$('.presentation-every-room').empty().append(data.html);
						}
						if (JSON.stringify(initContents[key]) != JSON.stringify(data.rows[key])) {
							initContents = data.rows;
							$('.presentation-every-room').empty().append(data.html);
						}
					});
		
					Object.keys(mRoom).map(function(key, idx) {
						let keyIndex = data.rooms.ourIndexOf(mRoom[key].id,'id');
						if (keyIndex === -1) {
							mRoom = data.rooms;
							$('.presentation-every-room').empty().append(data.html);
						}
		
						if (JSON.stringify(data.rooms[keyIndex]) != JSON.stringify(mRoom[key])) {
							mRoom = data.rooms;
							$('.presentation-every-room').empty().append(data.html);
						}
					});
				}

				break
			case 'main':
				Object.keys(initContents).map(function(key, idx) {
					let keyIndex = data.rows.ourIndexOf(initContents[key].m_room_id,'m_room_id');
					if (keyIndex != -1 && (JSON.stringify(initContents[key]) != JSON.stringify(data.rows[keyIndex]) || data.pgm_map[initContents[key].m_room_id] != pgmMap[initContents[key].m_room_id])) {
						location.reload();
					}
				});
				break;

		}
		const now = new Date()
		const formatTime = ('00'+now.getHours()).slice(-2)+':'+('00'+now.getMinutes()).slice(-2)
		if(document.getElementById('time')) {
			document.getElementById('time').innerText = formatTime
		}
	}
	// 特定の条件を満たしたらループ停止
	//if(any) {
		setTimeout(()=>viewerMainLoop(intervalSpan),intervalSpan)
	//}
}

let receipt_count = 0
window.viewerRoomsLoop = async (intervalSpan) => {
	receipt_count++;
	const response = await axios.get("/viewer/recept/get_viewer_rooms_data")
	const data = response.data;

	if (data) {
		// ルームの件数が違った場合
		var scrollX = document.getElementById('nativeAppBody').scrollLeft;
		var scrollY = document.getElementById('nativeAppBody').scrollTop;
		var viewType = document.querySelector('.list_switch .active a').getAttribute('data-type');
		var url = location.protocol + '//' + location.host + location.pathname;
		if (Object.keys(roomsData).length != Object.keys(data.rows).length) {
			window.location.href = url+'?scrollX='+scrollX+'&scrollY='+scrollY+'&viewType='+viewType;
		}

		Object.keys(roomsData).map(function(key, index) {
			// 画面上で表示されるルームが存在しない場合
			if (data.rows && typeof data.rows[key] == "undefined") {
				window.location.href = url+'?scrollX='+scrollX+'&scrollY='+scrollY+'&viewType='+viewType;;
			}
			// 画面上に表示され各ルームの件数違った場合
			if (roomsData[key].length != data.rows[key].length) {
				window.location.href = url+'?scrollX='+scrollX+'&scrollY='+scrollY+'&viewType='+viewType;;
			}
			// 各ルームの内容を文字列として変換し、違う内容が存在する場合
			if (JSON.stringify(roomsData[key]) != JSON.stringify(data.rows[key])) {
				window.location.href = url+'?scrollX='+scrollX+'&scrollY='+scrollY+'&viewType='+viewType;;
			}
		});
	}
	
	setTimeout(()=>viewerRoomsLoop(intervalSpan),intervalSpan)
}

window.congestionClassAdd = async (elem,congestion_cd) => {
	elem.classList.remove("is__empty", "is__many", "is__crowded", "is__full");
	switch(congestion_cd)
	{
		case '1':
			elem.classList.add('is__empty');
			break
		case '2':
			elem.classList.add('is__many');
			break
		case '3':
			elem.classList.add('is__crowded');
			break
		case '4':
			elem.classList.add('is__full');
			break
	}
}

Array.prototype.ourIndexOf = function(v,key) {
	for ( var i = 0, length = this.length; i < length; i++ ) {
        if ( this[i][key] == v ) {
            return i;
        }
    }
    return -1;
};

window.viewerRoomAddCheck = async (interval,mRoomId) => {
	const response = await axios.get("/viewer/room/is_room_has_add/"+mRoomId)
	let result = response.data

	if (result > 0) {
		window.location.reload();
	}
	setTimeout(()=>viewerRoomAddCheck(interval,mRoomId),interval)
}

window.viewerRoomAdChanged = async (interval,mRoomId) => {
	const response = await axios.get("/viewer/room/is_room_ad_changed/"+mRoomId)
	let result = response.data
	if (JSON.stringify(result.ad_lists) != JSON.stringify(ad_lists)) {
		window.location.reload();
	}
	setTimeout(()=>viewerRoomAdChanged(interval,mRoomId),interval)
}

if(typeof scrollYInit !== "undefined") $('#nativeAppBody').scrollTop(scrollYInit)
if(typeof scrollXInit !== "undefined") $('#nativeAppBody').scrollLeft(scrollXInit)


$(document).on('click', async function(e) {

	// ２．クリックされた場所の判定
	if(!$(e.target).closest('.popup_content').length && !$(e.target).closest('td').length){
		$('.popup,.popup_inner,.popup_content').fadeOut();
		$('.popup_content').empty();
	}else if($(e.target).closest('td').length){

	// ３．ポップアップの表示状態の判定
	if($('.popup_content').is(':hidden')){
		let t_pgm_subject_id = $(e.target).closest('td').data('t_pgm_subject_id');
		const response = await axios.get("/viewer/recept/get_subject_details/"+t_pgm_subject_id)
		let result = response.data
		$('.popup_content').empty().html(result.html);
		$('.popup,.popup_inner,.popup_content').fadeIn();
	}else{
		$('.popup,.popup_inner,.popup_content').fadeOut();
		$('.popup_content').empty();
	}
	}
});